import { OrderConfigResponse } from '@ca/common'

// `final_price` is client-only: the ERP never returns it and the patch input
// schema strips it, so a refreshed result loses the price a discount produced
const preserveFinalPrices = (
  incoming: OrderConfigResponse,
  previous: OrderConfigResponse | null | undefined,
  patchedIds: Set<number>
): OrderConfigResponse => {
  if (!previous) {
    return incoming
  }
  const byId = new Map(
    previous.orders.map((order) => [order.id, order.final_price])
  )
  return {
    ...incoming,
    orders: incoming.orders.map((order) => {
      const finalPrice = byId.get(order.id)
      // A patched order carries a fresh ERP amount, so its old final price is stale
      if (patchedIds.has(order.id) || finalPrice === undefined) {
        return order
      }
      return { ...order, final_price: finalPrice }
    }),
  }
}

export default preserveFinalPrices
